/**
 * Imposta il valore di una select `data-wx="searchable-select"` e riallinea il widget del tema
 * senza emettere `change`. `refresh()` rilegge le option ma ripristina la selezione precedente:
 * il primo riprende le option (anche rigenerate), il secondo il nuovo valore.
 * Senza istanza (observer Weext non ancora passato) basta la select: il widget la legge alla creazione.
 */
export function impostaSearchableSelect(select: HTMLSelectElement | null, valore: string): void {
  if (!select) return;
  const widget = Weext.SearchableSelect.getInstance(select);
  widget?.refresh();
  select.value = valore;
  widget?.refresh();
}
